/**
 * 
 * This code is for BL Form print view
 * 
 * 
 */


import React, { useEffect, useState } from "react";
import './view.css'
import { blformService } from "../../../services";
import { useParams } from "react-router-dom";
import { Button, Col, Row } from "antd";

export const DocReceiptPDF = () => {

    const { id } = useParams();

    const [loading, setLoading] = useState(false);
    const [blform, setBlform] = useState({});

    const initialize = async () => {
        setLoading(true);
        const { success, data } = await blformService.view(id);
        if (success) {
            setBlform(data);
        }
        setLoading(false);
    };

    const download = async () => {
        document.title = `${blform?.form?.booking_no} - BL Form`
        window.print()
    }

    useEffect(() => {
        initialize();
    }, [id]);

    return (
        <div className="watermark-container">
            <Row>
                <Col span={24} style={{ marginTop: 10, textAlign: "center" }}>
                    <Button type="primary" className="no-print" loading={loading} onClick={download}>
                        Download Dock Receipt
                    </Button>
                </Col>
            </Row>
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginBottom: "20px",
                    backgroundColor: "transparent",
                    padding: 10
                }}
                className="contaimermain2"
            >
                {blform.particulars?.map((particular, index) => (
                    <div
                        key={index}
                        style={{
                            borderRadius: 8,
                            marginBottom: "20px",
                            width: "100%",
                            ...(index !== 0 && { pageBreakBefore: "always", breakBefore: "page" })
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "15px",
                                padding: 8,
                            }}
                        >
                        </div>

                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", color: "#620108" }}>
                            <img src="/images/ctrade-logo2.png" style={{ height: '120px', width: "220px" }} />
                            <h1 style={{ textAlign: "center", fontWeight: "bold", fontSize: 38 }}>
                                HOUSE BILL OF LADING
                            </h1>
                        </div>

                        <div
                            style={{
                                width: "100%",
                                border: "1px solid lightgray",
                                display: "flex",
                            }}
                        >
                            <div className="left" style={{ width: "50%", }}>
                                <div
                                    style={{ border: "1px solid lightgray", height: "130px" }}
                                    className="cont3"
                                >
                                    <h6 style={{ height: "20px" }}>
                                        2. Exporter (Principal or seller-licensee and address
                                        including ZIP Code)
                                    </h6>
                                    <p>
                                        {particular.shipper} <br />
                                        {particular.shipper_address} <br />
                                        EMAIL: {particular.shipper_email}<br />
                                        PH: {particular.shipper_phone}
                                    </p>
                                </div>
                                <div style={{ border: "1px solid lightgray", height: "200px" }}>
                                    <h6>3. Consigned To:</h6>
                                    <p style={{ fontSize: 18 }}>
                                        {blform?.form?.consignee?.split('\n').map((line, index) => (
                                            <React.Fragment key={index}>
                                                {line}
                                                <br />
                                            </React.Fragment>
                                        ))}
                                        {blform?.form?.shipper_email && <span>EMAIL: {blform?.form?.consignee_email}</span>}
                                        {/* EMAIL: {blform?.form?.shipper_email} */}
                                    </p>
                                </div>
                                <div style={{ border: "1px solid lightgray", height: "100px" }}>
                                    <h6>
                                        4. Notify Party / Intermediate Consignee (Name and Address):
                                        <br />
                                        Tel:{blform?.form?.party_tel}
                                    </h6>
                                </div>
                                <div className="leftInner" style={{ display: "flex" }}>
                                    <div
                                        style={{
                                            height: "100px",
                                            border: "1px solid lightgray",
                                            width: "50%",
                                        }}
                                    >
                                        <h6>12. Pre-Carriage By</h6>
                                        <p>{blform?.form?.carriage}</p>
                                    </div>
                                    <div
                                        style={{
                                            height: "100px",
                                            border: "1px solid lightgray",
                                            width: "50%",
                                        }}
                                    >
                                        <h6>13. Place of Receipt by Pre-Carrier</h6>
                                        <p>{blform?.form?.place_of_reciept}</p>
                                    </div>
                                </div>
                                <div className="leftInner" style={{ display: "flex" }}>
                                    <div
                                        style={{
                                            height: "100px",
                                            border: "1px solid lightgray",
                                            width: "50%",
                                        }}
                                    >
                                        <h6>14. Exporting Carrier</h6>
                                        <p>{blform?.form?.exporting_carrier}</p>
                                    </div>
                                    <div
                                        style={{
                                            height: "100px",
                                            border: "1px solid lightgray",
                                            width: "50%",
                                        }}
                                    >
                                        <h6>15. Port of Loading/Export</h6>
                                        <p>{blform?.form?.port}</p>
                                    </div>
                                </div>
                                <div className="leftInner" style={{ display: "flex" }}>
                                    <div
                                        style={{
                                            height: "100px",
                                            border: "1px solid lightgray",
                                            width: "50%",
                                        }}
                                    >
                                        <h6>16. Foreign Port of Unloading (vessel and air only)</h6>
                                        <p>{blform?.form?.discharge}</p>
                                    </div>
                                    <div
                                        style={{
                                            height: "100px",
                                            border: "1px solid lightgray",
                                            width: "50%",
                                        }}
                                    >
                                        <h6>17. Place of Delivery by On-Carrier</h6>
                                        <p>{blform?.form?.place_of_delivery}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="right" style={{ width: "50%" }}>
                                <div className="leftInner" style={{ display: "flex" }}>
                                    <div
                                        style={{
                                            height: "80px",
                                            border: "1px solid lightgray",
                                            width: "50%",
                                        }}
                                    >
                                        <h6 style={{ height: '45px' }}>5. Document No. (Carrier Booking No.)</h6>
                                        <p>{blform?.form?.booking_no}</p>
                                    </div>
                                    <div
                                        style={{
                                            height: "80px",
                                            border: "1px solid lightgray",
                                            width: "50%",
                                        }}
                                    >
                                        <h6 style={{ height: '35px' }}>5a. Bill of Loading No</h6>
                                        <p>{blform?.form?.loading_no}</p>
                                    </div>
                                </div>
                                <div className="leftInner" style={{ display: "flex" }}>
                                    <div
                                        style={{
                                            height: "100px",
                                            border: "1px solid lightgray",
                                            width: "50%",
                                        }}
                                    >
                                        <h6>6. Export References</h6>
                                        <p>
                                            {particular.itn_number} <br />
                                            {blform?.form?.export_references}
                                        </p>
                                    </div>
                                    <div
                                        style={{
                                            height: "100px",
                                            border: "1px solid lightgray",
                                            width: "50%",
                                        }}
                                    >
                                        <h6>6a. Reference No.</h6>
                                        <p>{blform?.form?.reference_no}</p>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        height: "150px",
                                        width: "400px",
                                    }}
                                >
                                    <h6>7. Forwarding Agent (Name and Address)</h6>
                                    <br />
                                    <p>{blform?.form?.agent}</p>
                                </div>
                                <div
                                    style={{
                                        height: "60px",
                                        border: "1px solid lightgray",
                                        width: "100%",
                                    }}
                                >
                                    <h6>8. Point (State) or Origin or FTZ Number</h6>
                                    <p>{blform?.form?.point}</p>
                                </div>
                                <div style={{ border: "1px solid lightgray", height: "140px" }}>
                                    <h6>9. Also Notify and/or Additional Routing Instructions</h6>
                                    <p>{blform?.form?.party_instructions}</p>
                                </div>
                                <div className="leftInner" style={{ display: "flex" }}>
                                    <div
                                        style={{
                                            height: "100px",
                                            border: "1px solid lightgray",
                                            width: "50%",
                                        }}
                                    >
                                        <h6>10. Loading Pier / Terminal</h6>
                                        <p>{blform?.form?.loading_pier_terminal}</p>
                                    </div>
                                    <div
                                        style={{
                                            height: "100px",
                                            border: "1px solid lightgray",
                                            width: "50%",
                                        }}
                                    >
                                        <h6>10a. Closing Date</h6>
                                        <p>{blform?.form?.closing_date}</p>
                                    </div>
                                </div>
                                <div className="leftInner" style={{ display: "flex" }}>
                                    <div
                                        style={{
                                            height: "100px",
                                            border: "1px solid lightgray",
                                            width: "50%",
                                        }}
                                    >
                                        <h6>11. Type of Move</h6>
                                        <p>{blform?.form?.type_of_movement}</p>
                                    </div>
                                    <div
                                        style={{
                                            height: "100px",
                                            border: "1px solid lightgray",
                                            width: "50%",
                                        }}
                                    >
                                        <h6>11a. Containerized(Vessel only)</h6>
                                        <p>{blform?.form?.containerized}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ textAlign: "center" }}>
                            <h1 style={{ padding: 2, fontSize: 20 }}>PARTICULARS FURNISHED BY SHIPPER</h1>
                        </div>
                        <div
                            className="avoid-page-break"
                            style={{
                                border: "1px solid lightgray",
                                width: "100%",
                                display: "flex",
                                flexWrap: "wrap",
                            }}
                        >
                            <div
                                style={{
                                    border: "1px solid lightgray",
                                    width: "15%",
                                    minHeight: "100px", // Adaptive height
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <div
                                    style={{
                                        minHeight: "45px",
                                        borderBottom: "1px solid lightgray",
                                        marginBottom: 10,
                                    }}
                                >
                                    <h6>Marks and Numbers(18).</h6>
                                </div>
                                <p ><span style={{ fontSize: 12 }}>CONTAINER NO.:</span> {blform?.form?.container_nos}</p>
                                <p><span style={{ fontSize: 12 }}>SEAL:</span> {blform?.form?.seal_nos}</p>
                            </div>
                            <div style={{ flex: "1", display: "flex", flexDirection: "column" }}>
                                <div style={{ display: "flex", flexWrap: "wrap" }}>
                                    <div
                                        style={{
                                            border: "1px solid lightgray",
                                            width: "15%",
                                            minHeight: "100px",
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <h6 style={{ minHeight: "45px", borderBottom: "1px solid lightgray" }}>
                                            Number of Packages(19).
                                        </h6>
                                        <div style={{ paddingTop: 10 }}>
                                            <p>{particular?.quantity}</p>
                                        </div>
                                    </div>
                                    {/* Description + Value + Weight Box Combined in Rows */}
                                    <div
                                        style={{
                                            border: "1px solid lightgray",
                                            flex: "1",
                                            minHeight: "100px",
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <div
                                            style={{
                                                minHeight: "45px",
                                                borderBottom: "1px solid lightgray",
                                                display: "flex",

                                            }}
                                        >
                                            <h6 style={{ flex: 8 }}>Description of Commodities in Schedule B detail(20).</h6>
                                            {/* <h6 style={{ flex: 2, textAlign: "center" }}>Value</h6> */}
                                            <h6 style={{ flex: 2, borderLeft: "2px solid lightgray" }}>Gross Weights(21).</h6>
                                        </div>

                                        {(() => {
                                            const descArr = particular?.description?.split('\n') || [];
                                            const valueArr = particular?.value?.split('\n') || [];
                                            const weightArr = particular?.weight?.split('\n') || [];
                                            const maxLength = Math.max(descArr.length, valueArr.length, weightArr.length);

                                            return Array.from({ length: maxLength }).map((_, index) => (
                                                <div key={index} style={{ display: "flex" }}>
                                                    <div style={{ flex: 8, padding: "5px 10px", fontSize: "15px" }}>
                                                        {descArr[index] || ""}
                                                    </div>
                                                    <div style={{ flex: 2, padding: "5px 10px", fontSize: "15px", textAlign: "center" }}>
                                                        {valueArr[index] || ""}
                                                    </div>
                                                    <div style={{ flex: 2.45, padding: "5px 10px", borderLeft: "3px solid lightgray", fontSize: "15px", textAlign: "center" }}>
                                                        {weightArr[index] || ""}
                                                    </div>
                                                </div>
                                            ));
                                        })()}
                                    </div>

                                    <div
                                        style={{
                                            border: "1px solid lightgray",
                                            width: "19%",
                                            minHeight: "100px",
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <h6 style={{ minHeight: "45px", borderBottom: "1px solid lightgray" }}>
                                            Measurement(22).
                                        </h6>
                                        <div style={{ padding: 10 }}>
                                            <p>{particular.measurements}</p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        border: "1px solid lightgray",
                                        width: "100%",
                                        minHeight: "45px",
                                    }}
                                >
                                    <p>{blform?.form?.note_1}</p>
                                </div>
                            </div>
                        </div>
                        <div className="avoid-page-break" style={{
                            display: "flex", flexDirection: "row", height: '320px'
                        }}>
                            <div style={{ height: "100%", width: "60%", border: "1px solid lightgray", paddingTop: 10 }}>
                                <p>DELIVERED BY:</p>
                                <p>LIGHTER TRUCK:</p>
                                <p>ARRIVED- DATE:  TIME:</p>
                                <p>UNLOADED- DATE:  TIME:</p>
                                <p>CHECKED BY:</p>
                                <p>PLACED IN SHIP LOCATION:</p>
                                <p>ON DOCK</p>
                            </div>
                            <div style={{ height: "100%", width: "40%", border: "1px solid lightgray", paddingTop: 10 }}>
                                <p style={{ fontWeight: "bold" }}>RECEIVED THE ABOVE DESCRIBED GOODS OR PACKAGES SUBJECT TO ALL THE TERMS OF THE UNDERSIGNED'S REGULAR FORM OF DOCK RECEIPT AND BILL OF LADING WHICH SHALL CONSTITUTE THE CONTRACT UNDER WHICH THE GOODS ARE RECEIVED, COPIES OF WHICH ARE AVAILABLE FROM THE CARRIER ON REQUEST AND MAY BE INSPECTED AT ANY OF ITS OFFICES.</p>
                                <p>FOR THE MASTER
                                    BY   __________</p>
                                <p>RECEIVING CLERK
                                    DATE   __________</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    )
}